/**
 * i18n configuration for Pulse.
 *
 * Single namespace: 'pulse'. English and Spanish (Peru) supported.
 * Uses HttpBackend for runtime loading and LanguageDetector for auto-detection.
 */

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'es-PE', label: 'Spanish (Peru)', nativeLabel: 'Español (Peru)' },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]['code'];

export const ALL_NAMESPACES = ['pulse'] as const;

export type I18nNamespace = (typeof ALL_NAMESPACES)[number];

const storedLocale = localStorage.getItem('pulse.locale');
if (storedLocale && !SUPPORTED_LOCALES.map((l) => l.code).includes(storedLocale as SupportedLocale)) {
  localStorage.removeItem('pulse.locale');
}

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es-PE'],
    defaultNS: 'pulse',
    ns: ALL_NAMESPACES as unknown as string[],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pulse.locale',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18next;
